export default {
    list: {
        en: "English",
        it: "Italian",
        ru: "Russian",
        es: "Spanish",
    },
}
